import axios from "axios";
import { server } from "../../server";

// Load user
export const loadUser = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadUserRequest" });
    const { data } = await axios.get(server + "/user/getuser", { withCredentials: true });
    dispatch({ type: "LoadUserSuccess", payload: data.user });
  } catch (error) {
    dispatch({ type: "LoadUserFail", payload: error.response?.data?.message });
  }
};

// Logout user
export const logoutUser = () => async (dispatch) => {
  try {
    await axios.get(server + "/user/logout", { withCredentials: true });
    dispatch({ type: "LogoutUserSuccess" });
  } catch (error) {
    dispatch({ type: "LogoutUserFail", payload: error.response?.data?.message });
  }
};

// Update user info
export const updateUserInformation = (name, email, phoneNumber, password) => async (dispatch) => {
  try {
    dispatch({ type: "updateUserInfoRequest" });
    const { data } = await axios.put(
      server + "/user/update-user-info",
      { name, email, phoneNumber, password },
      { withCredentials: true }
    );
    dispatch({ type: "updateUserInfoSuccess", payload: data.user });
  } catch (error) {
    dispatch({ type: "updateUserInfoFailed", payload: error.response?.data?.message });
  }
};

// Update user address
export const updateUserAddress = (addressData) => async (dispatch) => {
  try {
    dispatch({ type: "updateUserAddressRequest" });
    const { data } = await axios.put(server + "/user/update-user-addresses", addressData, { withCredentials: true });
    dispatch({ type: "updateUserAddressSuccess", payload: data.user });
  } catch (error) {
    dispatch({ type: "updateUserAddressFailed", payload: error.response?.data?.message });
  }
};

// Update user address by ID
export const updateUserAddressById = (id, addressData) => async (dispatch) => {
  try {
    dispatch({ type: "updateUserAddressRequest" });
    const { data } = await axios.put(`${server}/user/update-user-address/${id}`, addressData, { withCredentials: true });
    dispatch({ type: "updateUserAddressSuccess", payload: data.user });
  } catch (error) {
    dispatch({ type: "updateUserAddressFailed", payload: error.response?.data?.message });
  }
};

// Delete user address
export const deleteUserAddress = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteUserAddressRequest" });
    const { data } = await axios.delete(server + "/user/delete-user-address/" + id, { withCredentials: true });
    dispatch({ type: "deleteUserAddressSuccess", payload: data.user });
  } catch (error) {
    dispatch({ type: "deleteUserAddressFailed", payload: error.response?.data?.message });
  }
};

// ADMIN: Get all users
export const getAllUsers = (page, limit) => async (dispatch) => {
  try {
    dispatch({ type: "getAllUsersRequest" });
    let url = `${server}/user/admin-all-users`;
    if (page && limit) {
      url += `?page=${page}&limit=${limit}`;
    } else {
      url += `?limit=all`;
    }
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({
      type: "getAllUsersSuccess",
      payload: {
        users: data.users,
        totalPages: data.totalPages || 1,
        totalUsers: data.totalUsers,
        bannedUsers: data.bannedUsers || 0,
        adminUsers: data.adminUsers || 0,
        activeUsers: data.activeUsers || 0,
        currentPage: data.currentPage || 1,
      },
    });
  } catch (error) {
    dispatch({ type: "getAllUsersFailed", payload: error.response?.data?.message });
  }
};

// Load seller
export const loadSeller = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadSellerRequest" });
    const { data } = await axios.get(server + "/shop/getSeller", { withCredentials: true });
    dispatch({ type: "LoadSellerSuccess", payload: data.seller });
  } catch (error) {
    dispatch({ type: "LoadSellerFail", payload: error.response?.data?.message });
  }
};

// Logout seller
export const logoutSeller = () => async (dispatch) => {
  try {
    await axios.get(server + "/shop/logout", { withCredentials: true });
    dispatch({ type: "LogoutSellerSuccess" });
  } catch (error) {
    dispatch({ type: "LogoutSellerFail", payload: error.response?.data?.message });
  }
};
